interface DemoBookedPayload {
  name: string;
  email: string;
  phone: string;
}

export function trackDemoBooked({ name, email, phone }: DemoBookedPayload): void {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: 'demo_booked', name, email, phone });
}
